export default __webpack_public_path__ + "static/media/add.9a045bb4.svg";